import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { SendSMSDialog, SendSMSDialogResult } from './send-sms.dialog';

@Injectable({
  providedIn: 'root'
})
export class SendSMSServiceDialog {

    constructor(public dialog: MatDialog) {}

    public open(
        customer: CustomerInterface,
        template: string,
        callback: (job: any, body?: string) => void
    ) {
        let dialog = this.dialog.open(SendSMSDialog, {
            width: '650px',
            data: {customer, template}
        });

        dialog.afterClosed().subscribe((result?: SendSMSDialogResult) => {
            callback(result?.job, result?.body);
        })
    }
}
